import workspaceQuery from '../../../graphql/queries/company/CommonImportTemplateWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CommonImportTemplateListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CommonImportTemplateQuery.graphql';
import mutationQuery from '../../../graphql/mutations/company/CommonImportTemplateMutation.graphql';
import fragment from '../../../graphql/fragments/company/CommonImportTemplateFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const CommonImportTemplate: EntityType = {
  type: 'ImportTemplate',
  title: 'Import Templates',
  formTitle: 'Import Template',
  formUrl: '/Company/ImportTemplate/Details/',
  workspaceUrl: '/Company/ImportTemplate/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'COMMON_IMPORT_TEMPLATE',
};

export default CommonImportTemplate;
